export interface DateRange {
  startDate?: string;
  endDate?: string;
  nameDateRange?: string;
}

export enum NameDateRange {
  GeneralPerformance = 'GeneralPerformance',
  VisitorActivity = 'VisitorActivity',
  SalesAnalytics = 'SalesAnalytics',
}
